<template>
    <div class="video-swiper">
        <div class="video-container">
            <div
                class="single-video"
                v-for="(item, index) in videoList"
                :key="index"
                v-if="index < 6"
                @click="toVideo(item)"
            >
                <img :src="item.img" alt />
                <div class="video-title">{{ item.title }}</div>
                <div class="video-icon">
                    <span>
                        <i class="el-icon-video-play"></i>
                        {{item.views}}
                    </span>
                    <span v-if="item.money > 0">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icondaozhangshijian" />
                        </svg>
                        {{item.money}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // 必须引用
    import 'swiper/dist/css/swiper.css';
    export default {
        components: {},
        props: {
            videoList: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },
        data() {
            return {};
        },
        computed: {},
        created() {},
        methods: {
            toVideo(item) {
                this.httpGet(this.$root.getCrumbsDetail, {
                    id: item.id,
                    type: 'article'
                })
                    .then(result => {
                        // 面包屑
                        let breadObj = [
                            {
                                id: result.id,
                                path: 'article-list?id=' + result.id,
                                name: result.title
                            }
                        ];
                        if (result.children.length) {
                            breadObj.push({
                                id: result.children.id,
                                path: 'article-list?id=' + result.children.id,
                                name: result.children.title
                            });
                        }
                        this.$store.commit('setBreadArr', breadObj);
                    })
                    .catch(err => {
                        console.error('getCrumbsDetail-err', err);
                    });
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: item.id
                    }
                });
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .video-swiper {
        width: 100%;
    }

    .video-container {
        flex-x(space-between);
        flex-wrap: wrap;
    }

    .single-video {
        height: 263px;
        width: 248px;
        background: white;
        border-radius: 8px;
        margin: 0 0 16px 0;
        padding: 16px;
        flex-y(flex-start, space-between);

        img {
            width: 100%;
            height: 186px;
        }
    }

    .single-video:hover {
        cursor: pointer;
    }

    .video-title {
        width: 100%;
        ellipsis();
        margin-top: 16px;
    }

    .video-icon {
        margin-top: 14px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        height: 17px;
        flex-x(flex-start);

        i {
            font-size: 14px;
            margin-right: 5px;
            color: #9DA4B3;
        }

        svg {
            icon-c(12px, #9DA4B3);
            fill: #9DA4B3;
            margin-right: 5px;
        }

        span {
            margin-right: 16px;
            flex-x();
        }
    }
</style>
